app.mediator.registerModule(MODULE_NAME__NEWS_ARTICLE_PAGE, function (app) {

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            this.$rootElem = $('.page-news-item');
            if (!this.$rootElem.length) return;
            this.addDomListeners();
            this.addMediatorListeners();
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function() {
            var scope = this;
            this.$rootElem.find('.social-share-button').click(function () {
                app.mediator.notify(EVENT_NAME__NEWS_ARTICLE_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED);
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {
        }
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

	};
});
